module.exports = __webpack_public_path__ + "img/join.93edae0e.png";